/**
 * Shared helpers for interpreting structured error codes returned by the API
 * (`{ error: string, message: string }`) that `apiClient.request()` attaches
 * to thrown `Error` objects as `.code`.
 */

export interface ApiError extends Error {
  code?: string;
}

export const getApiErrorCode = (error: unknown): string | undefined => {
  if (error instanceof Error) {
    return (error as ApiError).code;
  }
  return undefined;
};

/**
 * True when the error represents the backend's seat-entitlement gate
 * (`Failure.SeatEntitlement.Forbidden`) — the organization is over its seat pool, or
 * the calling user doesn't have an active seat.
 */
export const isSeatEntitlementError = (error: unknown): boolean =>
{
  const err = getApiErrorCode(error) 
  return err === 'Failure.SeatEntitlement.Forbidden' || 
  err === 'SeatEntitlement.Forbidden';
}
